<template>
    <div>
        <div class="efficiency">
            <div class="tctp">
                <ContentBox title="统仓统配" text="通过全渠道的供应链资源整合，不断去中间化，使供应链条更短，建立区域库存共享体系，有效盘活渠道库存，进而实现全渠道一盘货的整合，构建新型的智慧供应链，助力企业完善以客户为中心的营销体系">
                    <div>
                        <viewer v-if="COMMON.isMobile">
                            <img src="../../images/picture/tctp_main.png">
                        </viewer>
                        <img src="../../images/picture/tctp_main.png" v-else>
                    </div>
                </ContentBox>
            </div>
            <div class="xxjz">
                <ContentBox title="显性价值" theme="white">
                    <div>
                        <viewer  v-if="COMMON.isMobile">
                            <img src="../../images/picture/tctp_xxjz.png">
                        </viewer>
                        <img src="../../images/picture/tctp_xxjz.png" v-else>
                    </div>
                </ContentBox>
            </div>
            <div class="yxjz">
                <ContentBox title="隐性价值">
                    <div class="content">
                        <div>
                            <img src="../../images/icon/tctp_icon_ks.png">
                            <h5>可视决策</h5>
                            <p>渠道库存可视化，据此制定合理的产销存计划及相应政策</p>
                        </div>
                        <div>
                            <img src="../../images/icon/tctp_icon_gl.png">
                            <h5>管理严控</h5>
                            <p>严控代理商违规套利行为，营造公共透明的竞争环境</p>
                        </div>
                        <div>
                            <img src="../../images/icon/tctp_icon_gf.png">
                            <h5>统一规范</h5>
                            <p>渠道物流管理规范化、标准化、降低物流环节对产品品质影响，提升品牌形象</p>
                        </div>
                        <div>
                            <img src="../../images/icon/tctp_icon_jy.png">
                            <h5>节约成本</h5>
                            <p>减少不产生价值的物流中间环节，节约物流成本</p>
                        </div>
                    </div>
                </ContentBox>
            </div>
        </div>
    </div>
</template>
<style lang="less">
.efficiency {
    .title {
        font-size: 32px;
        margin: 1em 0;
        text-align: center;
    }
    img {
        margin: 0 auto;
        max-width: 100%;
    }
    .tctp {
        text-align: center;
        padding: 0 0 0.8rem;
        .title {
            color: #333333;
        }
    }
    .xxjz {
        text-align: center;
        background: url("../../images/picture/tctp_xxjz_bg.jpg") no-repeat;
        padding: 0.1rem 0 0.8rem;
        .title {
            color: #ffffff;
            margin-bottom: 0.5rem;
        }
    }
    .yxjz {
        padding-bottom: 1.4rem;
        text-align: center;
        .title {
            color: #333333;
        }
        .content {
            display: flex;
            div {
                width: 2.5rem;
                flex: 1;
                margin: 0 0.27rem;
            }
        }
        h5 {
            font-size: 20px;
            color: #333333;
        }
        p {
            line-height: 1.8em;
            color: #666666;
        }
        img {
            margin-bottom: 0.32rem;
        }
    }
}
@media screen and (max-width: 1024px) {
    .efficiency{
        .tctp .sub-title{
            line-height: 0.40rem;
        }
    }
}
@media screen and (max-width: 480px) {
    .efficiency {
        .title {
            font-size: 16px;
            padding: 0.15rem;
        }
        .tctp {
            padding: 0 0.15rem 0.3rem;
        }
        .xxjz {
            padding: 0 0.15rem 0.4rem 0.15rem;
            .title {
                margin-bottom: 0.15rem;
            }
        }
        .yxjz {
            padding-bottom: 0.3rem;
            padding: 0.15rem;
            .content {
                width: 100%;
                flex-wrap: wrap;
                margin: 0 auto;
                div {
                    width: 50%;
                    min-width: 50%;
                    margin: 0;
                    padding: 0.25rem 0.05rem;
                    box-sizing: border-box;
                    border-right: 1px solid #e6e6e6;
                    border-bottom: 1px solid #e6e6e6;
                }
                div:nth-child(2n){
                    border-right: 0 none;
                }
                div:nth-child(3n){
                    border-bottom: 0 none;
                }
                div:nth-child(4n){
                    border-bottom: 0 none;
                }
            }
            h5 {
                font-size: 14px;
            }
            p {
                font-size: 12px;
                padding: 0 0.05rem;
                text-align: center;
                color: #999999;
            }
            img {
                width: 0.44rem;
                height: 0.44rem;
                margin-bottom: 0.1rem;
            }
        }
    }
}
</style>
<script>
import ContentBox from '../common/content-box';
export default {
    metaInfo: {
        title: '服务介绍及效率-安得智联'
    },
    name: 'efficiency',
    components: {ContentBox}
};
</script>